import { render, staticRenderFns } from "./SuperAdminDropdownMenu.vue?vue&type=template&id=2f14e675&scoped=true"
import script from "./SuperAdminDropdownMenu.vue?vue&type=script&lang=js"
export * from "./SuperAdminDropdownMenu.vue?vue&type=script&lang=js"
import style0 from "./SuperAdminDropdownMenu.vue?vue&type=style&index=0&id=2f14e675&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f14e675",
  null
  
)

export default component.exports